import { render, staticRenderFns } from "./ServicePlaceUsers.vue?vue&type=template&id=8b04b03e&scoped=true&"
import script from "./ServicePlaceUsers.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b04b03e",
  null
  
)

export default component.exports